/**
 * Achievements Mock Data
 * Mock achievement data for development and testing
 */

import {
  AchievementTier,
  AchievementType as BEAchievementType,
  createEmptyUserAchievements,
  type AchievementStanding,
  type UserAchievementsView
} from '../../../../pure-js/types/Achievement'
import { AchievementData, AchievementId } from '../../features/gamer/achievements/types/achievementTypes'

/**
 * Mock achievement data matching backend response format
 * NOTE: All achievements are set to uncompleted (false or 0) for testing
 */
export const mockAchievementData: AchievementData = {
  [AchievementId.COMPLETED_FIRST_GAME]: {
    value: false
  },
  [AchievementId.URANIUM_COLLECTED]: {
    value: 0,
    extraValue: 0
  },
  [AchievementId.INVITATION_SEND]: {
    value: 0
  },
  [AchievementId.TESTER]: {
    value: 0
  },
  [AchievementId.UI_MASTER]: {
    value: 0
  },
  [AchievementId.NO_SLEEP]: {
    value: 0
  },
  [AchievementId.LEADER]: {
    value: 0
  },
  [AchievementId.TROUBLE_MAKER]: {
    value: 0
  },
  [AchievementId.DIE_MANY_TIMES]: {
    value: 0
  },
  [AchievementId.NO_WORK_DONE]: {
    value: 0
  }
}

/** Placeholder tiers for mock data; real answers carry their own. */
const MOCK_ACHIEVEMENT_THRESHOLDS = { bronze: 1, silver: 5, gold: 10 }

export const MOCK_NOT_STARTED_STANDING: AchievementStanding = {
  value: 0,
  thresholds: MOCK_ACHIEVEMENT_THRESHOLDS,
  isLowerBetter: false,
  currentTier: null,
  nextTier: AchievementTier.BRONZE,
  progressPercent: 0
}

/** A person's achievements with nothing earned, except where a standing is given. */
export function buildMockUserAchievementsView(
  userId: string,
  standings: Partial<Record<BEAchievementType, AchievementStanding>> = {}
): UserAchievementsView {
  const everyStanding = Object.fromEntries(
    Object.values(BEAchievementType).map((type) => [type, standings[type] ?? MOCK_NOT_STARTED_STANDING])
  ) as Record<BEAchievementType, AchievementStanding>

  return { ...createEmptyUserAchievements(userId), standings: everyStanding }
}
